import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

export function cleannerError(errors: any, cleanner: any, timeOut: number = 3000) {
	if (errors) {
		setTimeout(() => Object.entries(errors).map(([key]: any) => cleanner(key)), timeOut);
	}
}

export function createMarkup(text: string | any, showDots?: boolean) {
	return {
		__html: `${text}${showDots === true ? "..." : ""}`,
	};
}

export function useLocationState<T>(
	defaultValue: T | any,
	redirectToWhenNull: string | null = null
): T {
	const state = useLocation().state as T;
	const navigate = useNavigate();
	useEffect(() => {
		if (!state && redirectToWhenNull) {
			navigate(redirectToWhenNull);
		}
	}, [state]);
	return state || defaultValue;
}

export function createUrl(image: File) {
	return URL.createObjectURL(image);
}

// export function QueryUrl(baseUrl: string, additionalSearchQuery: any) {
// 	if (additionalSearchQuery) {
// 		for (let key of Object.keys(additionalSearchQuery)) {
// 			let val = additionalSearchQuery[key];

// 			if (Array.isArray(val)) {
// 				if (val.length > 0) {
// 					const string = val.map((v) => `${key}=${v}`).join("&");
// 					if (baseUrl.includes("?")) {
// 						baseUrl += `&${string}`;
// 					} else {
// 						baseUrl += `?${string}`;
// 					}
// 				}
// 			} else if (typeof val === "boolean") {
// 				if (baseUrl.includes("?")) {
// 					baseUrl += `&${key}=${val}`;
// 				} else {
// 					baseUrl += `?${key}=${val}`;
// 				}
// 			} else {
// 				if (val) {
// 					if (baseUrl.includes("?")) {
// 						baseUrl += `&${key}=${val}`;
// 					} else {
// 						baseUrl += `?${key}=${val}`;
// 					}
// 				}
// 			}
// 		}
// 	}
// 	return baseUrl;
// }
